export const REGLAGES_IMPORT_AUDIO_PROJET_DEFAUTS = Object.freeze ({
  compresser      : true,
  debit_max_kbps  : 128,
  convertir_mono  : false,
  normaliser_gain : true,
});

export const REGLAGES_IMPORT_AUDIO_PROJET_DEBIT_MIN = 32;
export const REGLAGES_IMPORT_AUDIO_PROJET_DEBIT_MAX = 320;

export function normalise_reglages_import_audio_projet (pValeur)
  {
    const tSource = pValeur && typeof pValeur === "object"
      ? pValeur
      : {};
    const tDebitBrut = Number (tSource.debit_max_kbps);
    const tDebit = Number.isFinite (tDebitBrut)
      ? Math.round (tDebitBrut)
      : REGLAGES_IMPORT_AUDIO_PROJET_DEFAUTS.debit_max_kbps;

    return {
      compresser : typeof tSource.compresser === "boolean"
        ? tSource.compresser
        : REGLAGES_IMPORT_AUDIO_PROJET_DEFAUTS.compresser,
      debit_max_kbps : Math.max (
        REGLAGES_IMPORT_AUDIO_PROJET_DEBIT_MIN,
        Math.min (REGLAGES_IMPORT_AUDIO_PROJET_DEBIT_MAX, tDebit)
      ),
      convertir_mono : typeof tSource.convertir_mono === "boolean"
        ? tSource.convertir_mono
        : REGLAGES_IMPORT_AUDIO_PROJET_DEFAUTS.convertir_mono,
      normaliser_gain : typeof tSource.normaliser_gain === "boolean"
        ? tSource.normaliser_gain
        : REGLAGES_IMPORT_AUDIO_PROJET_DEFAUTS.normaliser_gain,
    };
  }